/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function LockSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'LockSmall',
      'aria-hidden': true,
      focusable: false,
      width:  10 * scale,
      height: 12 * scale,
      viewBox: '0 0 10 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M8 5.28V4c0-1.65-1.35-3-3-3S2 2.35 2 4v1.28c-.594.347-1 .985-1 1.72v3.5c0 .174.03.34.072.5H8.93c.04-.16.07-.326.07-.5V7c0-.735-.406-1.373-1-1.72M6 8.2c0 .44-.36.8-.8.8h-.4c-.44 0-.8-.36-.8-.8v-.4c0-.44.36-.8.8-.8h.4c.44 0 .8.36.8.8zM6.7 5H3.3V4c0-.937.763-1.7 1.7-1.7s1.7.763 1.7 1.7z"}))
}
